import React, { useEffect, useState, FunctionComponent, useRef } from 'react';
import { Column, Columns, Container } from '@codeparva/ui-components-library';
import { UnitCard } from '../../../../../components/unitDetailsCard/UnitCard';
import { mobilescreensize } from '../../../../../utilities/constants';
import { useWindowDimensions } from '../../../../../utilities/Dimensions';
import { ConfirmationSection } from '../../confirmation';
import { DynamicFormTypes } from '../DynamicFormTypes';
import { confirmationConfig, paymentUrl } from '../helper/config';
import { GetForm } from '../helper/GetForm';
import { getUpdatedFormData } from '../helper/GenericFormHelper';
import { useSectionData } from '../hooks/dataContext';
import {
  paymentRequestHandler,
  getPathName,
  getUpdatedAmount,
} from '../../../helpers/paymentComponentHelper';
import { useFormikContext } from 'formik';
import {
  callBackHandler,
  makeNoPaymentReservation,
} from '../helper/apiHelpers';
import { frameConfirmationConfig } from '../helper/MoveInReservationConfigHelper';
import { OtherPaymentErrorScreen } from '../../../../account/components/ErrorScreens/PaymentErrorScreen';
import { NewCardSection } from '../../../../account/components/PayRent/NewCardSection';
import { weakKey } from '../../../../../utilities/weakKey';
import { getPaymentMethodInfo } from '../../../../account/helpers/PaymentHelpers';
import { paymentMethodType } from '../../../../account/constants/accountPanelConfigs';
import { PaymentTypeSelector } from '../../../../account/components/PayRent/PaymentMethodTypeSelector';

export const GenericForm: FunctionComponent<DynamicFormTypes.IGenericForm> = ({
  genericFormData,
  unitsData,
  unitCardsConfig,
  bodyHeight,
  individualUnitDataContext,
  onSetIndividualData,
  facilityId,
  tenantIdFromCreationAPI,
  ledgerId,
  facilityContext,
  noPayReservationCallCount,
  setNoPayReservationCallCount,
  tenantToken,
}) => {
  const { width } = useWindowDimensions();
  const [paymentReq, setPaymentReq] = useState<
    DynamicFormTypes.TPaymentRequest | any
  >({});
  const [totalRate, setTotalRate] = useState(0);
  const [showPaymentMethodDropdown, setShowPaymentMethodDropdown] = useState(
    false
  );
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('default');
  const [isLoadingPaymentInfo, setIsLoadingPaymentInfo] = useState(false);

  let arrayData: { key: string; label: string; value: any }[] = [];
  const data = useSectionData();
  const paymentButtonRef = useRef<any>();
  const currentSelectedMethod = useRef<any>();
  const paymentMethodAmount = useRef<any>();
  const originalAmount = useRef<any>();
  const { path, gatsbyPathName, paymentComponentReq, tenantId } = data;
  const OriginalPathName = location.pathname;
  const pathName = getPathName(OriginalPathName, paymentUrl);
  const {
    tenantWebsitesConfigInfo: {
      data: [
        {
          value: {
            payment: {
              is_ach_payment_enabled: isAchPaymentEnabled = false,
            } = {},
            payment: tfwPaymentConfig = {},
          } = {},
        } = {},
      ] = [],
    } = {},
    facilityAndGlobalEncKeys: {
      facilityEncPublicKeysPerFid: { [facilityId]: facPublicKey = '' } = {},
    } = {},
  } = facilityContext || {};
  const [paymentType, setPaymentType] = React.useState(
    paymentMethodType.creditCard
  );

  useEffect(() => {
    if (selectedPaymentMethod !== 'default') {
      setSelectedPaymentMethod('default');
      // TODO: Set original amount
    }
  }, [paymentType]);

  useEffect(() => {
    try {
      async function fetchData() {
        if (genericFormData.label === 'Payment') {
          setIsLoadingPaymentInfo(true);
          const paymentRequest = await paymentRequestHandler(
            paymentComponentReq,
            gatsbyPathName,
            facilityId,
            facPublicKey,
            callBackHandler,
            data
          );
          paymentRequest.tenantId = tenantId;
          paymentRequest.tenantIdFromCreationAPI = tenantIdFromCreationAPI;
          paymentRequest.individualUnitData = individualUnitDataContext;
          paymentRequest.contextData = {
            ...data,
            paymentButtonRef,
          };
          const numRate = parseFloat(paymentRequest.configs.total_amount);
          setTotalRate(numRate);
          setShowPaymentMethodDropdown(
            paymentRequest.isSurchargeOrDiscountAvailable
          );
          setPaymentReq(paymentRequest);
          setIsLoadingPaymentInfo(false);
          if (!originalAmount.current) {
            originalAmount.current = paymentRequest.configs.total_amount;
          }
        } else if (genericFormData.label === 'Confirmation') {
          if (
            paymentComponentReq &&
            paymentComponentReq.total_amount === '0' &&
            noPayReservationCallCount === 0
          ) {
            setNoPayReservationCallCount(noPayReservationCallCount + 1);
            await makeNoPaymentReservation(
              paymentComponentReq,
              tenantToken,
              facilityId
            );
          }
        }
      }
      fetchData();
    } catch (e) {
      console.error('error in paymentRequest Handler', e);
      setIsLoadingPaymentInfo(false);
    }
  }, [genericFormData.label]);

  useEffect(() => {
    if (selectedPaymentMethod === 'default') {
      if (document.getElementById('payment-button')) {
        const paymentButton = document.getElementById(
          'payment-button'
        ) as HTMLButtonElement;
        paymentButton.disabled = true;
      }
    } else {
      if (document.getElementById('payment-button')) {
        const paymentButton = document.getElementById(
          'payment-button'
        ) as HTMLButtonElement;
        paymentButton.disabled = false;
      }
    }
  }, [selectedPaymentMethod]);

  const reCalculateTheFinalRate = async (selectedPaymentMethod: any) => {
    const payment_method_id = getPaymentMethodInfo(selectedPaymentMethod, 'id');
    const payment_method_modifier = getPaymentMethodInfo(
      selectedPaymentMethod,
      'modifier'
    );
    const {
      amount,
      surcharge_or_discount,
      amount_without_modifier,
    } = await getUpdatedAmount(
      payment_method_id,
      originalAmount.current,
      facilityId,
      tenantToken
    );
    const newConfig = { ...paymentReq.configs };
    newConfig.total_amount = amount;
    newConfig.surcharge_or_discount = surcharge_or_discount;
    newConfig.base_amount = amount_without_modifier;
    paymentMethodAmount.current = surcharge_or_discount;
    newConfig.selectedPaymentId = payment_method_id;
    setPaymentReq({
      ...paymentReq,
      configs: newConfig,
    });
    currentSelectedMethod.current = payment_method_modifier;
    setTotalRate(amount);
    setIsLoadingPaymentInfo(false);
  };

  const handleChange = (e: any) => {
    const { target: { value: selectedValue = null } = {} } = e || {};
    const { payment_method } = paymentReq;
    const filteredPaymentMethod = payment_method.data.filter(
      (eachPaymentMethod: any) => eachPaymentMethod.value.modifier
    );
    const selectedPaymentMethod = filteredPaymentMethod.find(
      (item: any) => item.id === selectedValue
    );

    if (selectedValue !== 'default') {
      setSelectedPaymentMethod(
        getPaymentMethodInfo(selectedPaymentMethod, 'id')
      );
    }

    if (selectedPaymentMethod) {
      setIsLoadingPaymentInfo(true);
      reCalculateTheFinalRate(selectedPaymentMethod);
    }
  };

  const getPaymentMethodOptions = (paymentMethod: any, paymentType: any) => {
    return paymentMethod.data.map((indivPaymentMethod: any) => {
      const payment_method_modifier = getPaymentMethodInfo(
        indivPaymentMethod,
        'modifier'
      );
      const payment_methodId = getPaymentMethodInfo(indivPaymentMethod, 'id');
      const modifierType =
        payment_method_modifier !== 'No_Modifier'
          ? `-${payment_method_modifier}`
          : '';
      return (
        indivPaymentMethod.value.type === paymentType &&
        indivPaymentMethod.value.status !== 'Inactive' && (
          <option
            value={payment_methodId}
            key={weakKey({ id: payment_methodId })}
          >
            {indivPaymentMethod.value.description}
            {modifierType}
          </option>
        )
      );
    });
  };

  const PaymentMethodSelectionDropDown = () => {
    const { payment_method } = paymentReq;
    return (
      <select value={selectedPaymentMethod} onChange={handleChange}>
        <option value="default">Select a Payment Method</option>
        {getPaymentMethodOptions(payment_method, paymentType)}
      </select>
    );
  };

  const PaymentSection = () => {
    useEffect(() => {
      const paymentButton = document.getElementById(
        'payment-button'
      ) as HTMLButtonElement;
      if (
        showPaymentMethodDropdown &&
        selectedPaymentMethod === 'default' &&
        paymentButton &&
        paymentButton.disabled !== true
      ) {
        // paymentButtonRef?.current && paymentButtonRef?.current.setAttribute('disabled', true);
        if (document.getElementById('payment-button')) {
          const paymentButton = document.getElementById(
            'payment-button'
          ) as HTMLButtonElement;
          paymentButton.disabled = true;
        }
      }
    }, []);
    return paymentReq.configs.total_amount ? (
      <>
        {window.history.pushState({}, '', `${pathName}/${paymentUrl}`)}
        {isAchPaymentEnabled && (
          <PaymentTypeSelector
            paymentType={paymentType}
            setPaymentType={setPaymentType}
          />
        )}
        <div className="select is-large is-primary paymentMethodDropdown">
          <PaymentMethodSelectionDropDown />
        </div>
        <NewCardSection
          {...paymentReq}
          isLoadingPaymentInfo={isLoadingPaymentInfo}
          tfwPaymentConfig={tfwPaymentConfig}
          paymentType={paymentType}
          setPaymentType={setPaymentType}
        />
      </>
    ) : (
      <OtherPaymentErrorScreen hideButton={true} />
    );
  };

  const UnitCardSectionHelper = (isConfirmation: boolean) => {
    return (
      <UnitCard
        unitsData={unitsData}
        individualUnitTypeData={individualUnitDataContext}
        height={bodyHeight}
        unitCardsConfig={unitCardsConfig}
        isConfirmationPage={isConfirmation}
        onSetIndividualData={onSetIndividualData}
        path={path}
        gatsbyPathName={gatsbyPathName}
        facilityId={facilityId}
        ledgerId={ledgerId || ''}
        modifierType={currentSelectedMethod.current}
        isSurchargeOrDiscountAvailable={showPaymentMethodDropdown}
        updatedRate={totalRate}
        surcharge_or_discount={paymentMethodAmount.current}
        tenantToken={tenantToken}
        facPublicKey={facPublicKey}
      />
    );
  };
  const getValues = (values: any) => {
    for (const key in values) {
      if (values[key] === '') {
        delete values[key];
      }
    }
    return values;
  };
  const renderComponent = () => {
    switch (genericFormData.label) {
      case 'Unit Details':
        return <>{UnitCardSectionHelper(false)}</>;
      case 'Confirmation':
        const { values }: any = useFormikContext();
        const updatedvalues = getValues(values);
        const res = getUpdatedFormData(updatedvalues, path);
        confirmationConfig.sections = [];
        frameConfirmationConfig(
          res,
          confirmationConfig,
          gatsbyPathName,
          arrayData
        );
        confirmationConfig.sections.map(
          (section: DynamicFormTypes.TSectionData) => {
            if (section.title === undefined) {
              delete section.title;
              delete section.fields;
            }
          }
        );
        const finalConfirmationConfig = confirmationConfig.sections.filter(
          (section: {}) => Object.keys(section).length
        );
        confirmationConfig.sections = finalConfirmationConfig;
        confirmationConfig.unitsData = unitsData;
        confirmationConfig.individualUnitsData = individualUnitDataContext;
        confirmationConfig.facilityId = facilityId;
        confirmationConfig.ledgerId = ledgerId || '';
        return (
          <ConfirmationSection
            confirmationSectionConfig={confirmationConfig}
            tenantToken={tenantToken}
            facPublicKey={facPublicKey}
          />
        );
      case 'Payment':
        return (
          <Columns className="paymentColumns">
            <Column>
              {Object.keys(paymentReq).length > 0 ? (
                <PaymentSection />
              ) : (
                <div className="loaderParentGenericForm">
                  <div className="loader"></div>
                </div>
              )}
            </Column>
            <Column>
              <Container>{UnitCardSectionHelper(true)}</Container>
            </Column>
          </Columns>
        );

      default:
        return (
          <Columns>
            <Column>
              <GetForm getFormData={genericFormData} />
            </Column>
            {width > mobilescreensize && (
              <Column
                className="is-flex is-justify-content-center is-align-items-flex-start"
                narrow={true}
              >
                {UnitCardSectionHelper(false)}
              </Column>
            )}
          </Columns>
        );
    }
  };

  return <>{renderComponent()}</>;
};
